import SelectedPackageCost from './SelectedPackageCost';

export default SelectedPackageCost;
